// import React,{useEffect, useState} from "react";
// import { FiCheck,FiX,FiArrowLeft } from "react-icons/fi";
// import { getCustomerSession } from "../../utils/applyFlowSession";

// import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"


// const formatBreReason = (reason) => {
//   if (!reason) {
//     return {
//       title: "",
//       detail: "",
//     };
//   }

//   const value = String(reason).trim().toLowerCase();

//   const operatorMap = {
//     lt: "<",
//     lte: "≤",
//     gt: ">",
//     gte: "≥",
//     eq: "=",
//     ne: "≠",
//   };

//   // Example:
//   // non_salaried_user_net_income_lt_20000
//   const incomeMatch = value.match(
//     /^non_salaried_user_net_income_(lt|lte|gt|gte|eq|ne)_(.+)$/
//   );

//   if (incomeMatch) {
//     const operator = operatorMap[incomeMatch[1]];

//     const amount = Number(
//       String(incomeMatch[2]).replace(/,/g, "")
//     );

//     return {
//       title: "Non-salaried user",
//       detail: `Net income ${operator} ₹${amount.toLocaleString(
//         "en-IN"
//       )}`,
//     };
//   }

//   // Generic BRE reason
//   const parts = value.split("_");

//   const operatorIndex = parts.findIndex(
//     (part) => operatorMap[part]
//   );

//   if (
//     operatorIndex > 0 &&
//     operatorIndex < parts.length - 1
//   ) {
//     const title = parts
//       .slice(0, operatorIndex)
//       .join(" ")
//       .replace(/\b\w/g, (char) => char.toUpperCase());

//     const rightValue = parts
//       .slice(operatorIndex + 1)
//       .join(" ");

//     const numericValue = Number(
//       rightValue.replace(/,/g, "")
//     );

//     const formattedValue = Number.isNaN(numericValue)
//       ? rightValue
//       : numericValue.toLocaleString("en-IN");

//     return {
//       title,
//       detail: `${operatorMap[parts[operatorIndex]]} ${formattedValue}`,
//     };
//   }

//   return {
//     title: value
//       .replace(/_/g, " ")
//       .replace(/\s+/g, " ")
//       .replace(/\b\w/g, (char) => char.toUpperCase()),
//     detail: "",
//   };
// };
// const ApprovedPage = ({
//   employment,
//   setActiveReferenceTab,
//   setReferenceError,
//   setScreen,
// }) => {
//   const [bankDecision, setBankDecision] = useState("");

// const [bankDecisionReason, setBankDecisionReason] =
//   useState("");

// const [bankLoanAmount, setBankLoanAmount] =
//   useState("");

// useEffect(() => {
//   const stored = getCustomerSession() || {};

//   const decision = String(
//     stored?.bank_bre_decision ||
//     stored?.bankBreResponse?.data?.decision ||
//     ""
//   ).trim();

//   const reason = String(
//     stored?.bank_bre_decision_reason ||
//     stored?.bankBreResponse?.data?.decision_reason ||
//     ""
//   ).trim();

//   const loanAmount =
//     stored?.bank_bre_loan_amount ??
//     stored?.bankBreResponse?.data?.loan_amount ??
//     "";

//   setBankDecision(decision);
//   setBankDecisionReason(reason);
//   setBankLoanAmount(loanAmount);
// }, []);
// const formattedReason = formatBreReason(
//   bankDecisionReason
// );
//   return (
//    <section className={`fw-screen fw-screen--status fw-screen--approved fw-fade ${
//     String(bankDecision).toLowerCase() === "reject"
//       ? "fw-screen--rejected"
//       : ""
//   }`}
// >
//            <div className="fw-brandmain">
//           <img 
//             src={fundwalelogo} 
//             alt="Fundswalle" 
//             className="fw-brand__logo1" 
//           />
//         </div>
//         <div className="fw-approved__back">
//   <button
//     type="button"
//     onClick={() => setScreen("/apply-new/aaCallback")}
//     className="fw-approved__back-btn"
//   >
//     <FiArrowLeft />
//     <span>Back</span>
//   </button>
// </div>
//       <div className="fw-approved">

//         {/* <div className="fw-approved__fx" aria-hidden="true"> */}
//         <div
//   className={`fw-approved__fx ${
//     String(bankDecision).toLowerCase() === "reject"
//       ? "fw-approved__fx--reject"
//       : ""
//   }`}
//   aria-hidden="true"
// >
//           <span className="fw-approved__glow" />
//           <span className="fw-approved__ring" />
//           <span className="fw-approved__ring fw-approved__ring--2" />

//           {Array.from({ length: 14 }, (_, i) => (
//             <span
//               key={i}
//               className={`fw-approved__spark fw-approved__spark--${i + 1}`}
//             />
//           ))}
//         </div>

//         {/* <div className="fw-approved__hero">
//           <span className="fw-approved__icon">
//             <FiCheck />
//           </span>
//         </div>

//         <h2 className="fw-approved__title">
//           Congratulations! 
//         </h2> 

//         <p className="fw-approved__msg">
//           Your loan has been successfully approved.
//         </p>

//         {employment.loanAmount && (
//           <p className="fw-approved__amount">
//             ₹{Number(employment.loanAmount).toLocaleString("en-IN")}
//           </p>
//         )}

//         <span className="fw-approved__chip">
//           Pre-approved offer ready
//         </span> */}

// {String(bankDecision).toLowerCase() === "reject" ? (
//   <>
//     <div className="fw-approved__hero fw-approved__hero--reject">
//       <span className="fw-approved__icon fw-approved__icon--reject">
//         <FiX />
//       </span>
//     </div>

//     <h2 className="fw-approved__title fw-approved__title--reject">
//       Application Not Approved
//     </h2>

//     <p className="fw-approved__msg fw-approved__msg--reject">
//       We&apos;re sorry, but we&apos;re unable to proceed with your
//       loan application at this time.
//     </p>

//     {/* {bankDecisionReason && (
//       <div className="fw-rejection-reason">
//         <div className="fw-rejection-reason__label">
//           Reason
//         </div>

//         <div className="fw-rejection-reason__text">
//           {bankDecisionReason}
//         </div>
//       </div>
//     )} */}

//     {bankDecisionReason && (
//   <div className="fw-rejection-reason">
//     <div className="fw-rejection-reason__label">
//       Reason
//     </div>

//     <div className="fw-rejection-reason__title">
//       {formattedReason.title}
//     </div>

//     {formattedReason.detail && (
//       <div className="fw-rejection-reason__detail">
//         {formattedReason.detail}
//       </div>
//     )}
//   </div>
// )}

//     <span className="fw-approved__chip fw-approved__chip--reject">
//       Application not approved
//     </span>
//   </>
// ) : (
//   <>
//     <div className="fw-approved__hero">
//       <span className="fw-approved__icon">
//         <FiCheck />
//       </span>
//     </div>

//     <h2 className="fw-approved__title">
//       Congratulations!
//     </h2>

//     <p className="fw-approved__msg">
//       Your loan has been successfully approved.
//     </p>

//     {(bankLoanAmount || employment.loanAmount) && (
//       <p className="fw-approved__amount">
//         ₹
//         {Number(
//           bankLoanAmount || employment.loanAmount
//         ).toLocaleString("en-IN")}
//       </p>
//     )}

//     <span className="fw-approved__chip">
//       Pre-approved offer ready
//     </span>
//   </>
// )}
//       </div>

//       <div className="fw-screen__footer fw-approved__footer">
//         {/* <button
//           type="button"
//           className="fw-btn fw-btn--dark fw-btn--full"
//           onClick={() => {
//             setActiveReferenceTab(0);
//             setReferenceError("");
//             setScreen("/apply-new/referenceDetails");
//           }}
//         >
//           Proceed
//         </button> */}
//         {String(bankDecision).toLowerCase() !== "reject" && (
//   <button
//     type="button"
//     className="fw-btn fw-btn--dark fw-btn--full"
//     onClick={() => {
//       setActiveReferenceTab(0);
//       setReferenceError("");
//       setScreen("/apply-new/referenceDetails");
//     }}
//   >
//     Proceed
//   </button>
// )}
//       </div>
//     </section>
//   );
// };

// export default ApprovedPage;



import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FiCheck,
  FiX,
  FiArrowLeft,
} from "react-icons/fi";

import {
  getCustomerSession,
} from "../../utils/applyFlowSession";

import fundwalelogo from "../../assets/images/Fundswalle_Logo.png";

const formatBreReason = (reason) => {
  if (!reason) {
    return {
      title: "",
      detail: "",
    };
  }

  const value = String(reason)
    .trim()
    .toLowerCase();

  const operatorMap = {
    lt: "<",
    lte: "≤",
    gt: ">",
    gte: "≥",
    eq: "=",
    ne: "≠",
  };

  // Example:
  // non_salaried_user_net_income_lt_20000
  const incomeMatch = value.match(
    /^non_salaried_user_net_income_(lt|lte|gt|gte|eq|ne)_(.+)$/
  );

  if (incomeMatch) {
    const operator =
      operatorMap[incomeMatch[1]];

    const amount = Number(
      String(incomeMatch[2]).replace(/,/g, "")
    );

    return {
      title: "Non-salaried user",
      detail: `Net income ${operator} ₹${amount.toLocaleString(
        "en-IN"
      )}`,
    };
  }

  // Generic BRE reason
  const parts = value.split("_");

  const operatorIndex = parts.findIndex(
    (part) => operatorMap[part]
  );

  if (
    operatorIndex > 0 &&
    operatorIndex < parts.length - 1
  ) {
    const title = parts
      .slice(0, operatorIndex)
      .join(" ")
      .replace(
        /\b\w/g,
        (char) => char.toUpperCase()
      );

    const rightValue = parts
      .slice(operatorIndex + 1)
      .join(" ");

    const numericValue = Number(
      rightValue.replace(/,/g, "")
    );

    const formattedValue =
      Number.isNaN(numericValue)
        ? rightValue
        : numericValue.toLocaleString("en-IN");

    return {
      title,
      detail: `${
        operatorMap[parts[operatorIndex]]
      } ${formattedValue}`,
    };
  }

  return {
    title: value
      .replace(/_/g, " ")
      .replace(/\s+/g, " ")
      .replace(
        /\b\w/g,
        (char) => char.toUpperCase()
      ),
    detail: "",
  };
};

const ApprovedPage = ({
  employment,
  setActiveReferenceTab,
  setReferenceError,
  setScreen,
}) => {
   const location = useLocation();
  const [bankDecision, setBankDecision] =
    useState("");

  const [bankDecisionReason, setBankDecisionReason] =
    useState("");

  const [bankLoanAmount, setBankLoanAmount] =
    useState("");

  useEffect(() => {
    const stored =
      getCustomerSession() || {};

    // Existing session decision
    const decision = String(
      stored?.bank_bre_decision ||
        stored?.bankBreResponse?.data?.decision ||
        ""
    ).trim();

    const reason = String(
      stored?.bank_bre_decision_reason ||
        stored?.bankBreResponse?.data
          ?.decision_reason ||
        ""
    ).trim();

    const loanAmount =
      stored?.bank_bre_loan_amount ??
      stored?.bankBreResponse?.data
        ?.loan_amount ??
      "";

    // Backend eMandate redirect status
 const params = new URLSearchParams(
  location.search
);

const redirectStatus =
  params.get("status");

    console.log(
      "Approved Page Redirect Status:",
      redirectStatus
    );

    // URL status gets priority
    if (redirectStatus === "true") {
      setBankDecision("approve");
    } else if (
      redirectStatus === "false"
    ) {
      setBankDecision("reject");
    } else {
      // Existing flow remains unchanged
      setBankDecision(decision);
    }

    setBankDecisionReason(reason);
    setBankLoanAmount(loanAmount);
  }, [location.search]);

  const formattedReason =
    formatBreReason(
      bankDecisionReason
    );

  const isRejected =
    String(bankDecision).toLowerCase() ===
    "reject";

  return (
    <section
      className={`
        fw-screen
        fw-screen--status
        fw-screen--approved
        fw-fade
        ${isRejected ? "fw-screen--rejected" : ""}
      `}
    >
      <div className="fw-brandmain">
        <img
          src={fundwalelogo}
          alt="Fundswalle"
          className="fw-brand__logo1"
        />
      </div>

      {/* Back Button */}
      <div className="fw-approved__back">
        <button
          type="button"
          onClick={() =>
            setScreen(
              "/apply-new/aaCallback"
            )
          }
          className="fw-approved__back-btn"
        >
          <FiArrowLeft />
          <span>Back</span>
        </button>
      </div>

      <div className="fw-approved">

        {/* Animation */}
        <div
          className={`
            fw-approved__fx
            ${
              isRejected
                ? "fw-approved__fx--reject"
                : ""
            }
          `}
          aria-hidden="true"
        >
          <span className="fw-approved__glow" />

          <span className="fw-approved__ring" />

          <span className="fw-approved__ring fw-approved__ring--2" />

          {Array.from(
            { length: 14 },
            (_, i) => (
              <span
                key={i}
                className={`
                  fw-approved__spark
                  fw-approved__spark--${i + 1}
                `}
              />
            )
          )}
        </div>

        {/* =================================================
            REJECTED
           ================================================= */}

        {isRejected ? (
          <>
            <div className="fw-approved__hero fw-approved__hero--reject">
              <span className="fw-approved__icon fw-approved__icon--reject">
                <FiX />
              </span>
            </div>

            <h2 className="fw-approved__title fw-approved__title--reject">
              Application Not Approved
            </h2>

            <p className="fw-approved__msg fw-approved__msg--reject">
              We&apos;re sorry, but we&apos;re unable
              to proceed with your loan application
              at this time.
            </p>

            {bankDecisionReason && (
              <div className="fw-rejection-reason">
                <div className="fw-rejection-reason__label">
                  Reason
                </div>

                <div className="fw-rejection-reason__title">
                  {formattedReason.title}
                </div>

                {formattedReason.detail && (
                  <div className="fw-rejection-reason__detail">
                    {formattedReason.detail}
                  </div>
                )}
              </div>
            )}

            <span className="fw-approved__chip fw-approved__chip--reject">
              Application not approved
            </span>
          </>
        ) : (
          /* =================================================
             APPROVED
             ================================================= */
          <>
            <div className="fw-approved__hero">
              <span className="fw-approved__icon">
                <FiCheck />
              </span>
            </div>

            <h2 className="fw-approved__title">
              Congratulations!
            </h2>

            <p className="fw-approved__msg">
              Your loan has been successfully
              approved.
            </p>

            {(bankLoanAmount ||
              employment?.loanAmount) && (
              <p className="fw-approved__amount">
                ₹
                {Number(
                  bankLoanAmount ||
                    employment?.loanAmount
                ).toLocaleString("en-IN")}
              </p>
            )}

            <span className="fw-approved__chip">
              Pre-approved offer ready
            </span>
          </>
        )}
      </div>

      {/* Footer */}
      <div className="fw-screen__footer fw-approved__footer">

        {/* {!isRejected && (
          <button
            type="button"
            className="fw-btn fw-btn--dark fw-btn--full"
            onClick={() => {
              setActiveReferenceTab(0);
              setReferenceError("");
              setScreen(
                "/apply-new/referenceDetails"
              );
            }}
          >
            Proceed
          </button>
        )} */}
{!isRejected && (
  <button
    type="button"
    className="fw-btn fw-btn--dark fw-btn--full"
    onClick={() => {
      setActiveReferenceTab(0);
      setReferenceError("");

      const params = new URLSearchParams(
        window.location.search
      );
      const status = params.get("status");

      // Fail — stay on approved
      if (status === "false") {
        return;
      }

      // Approved success (with or without ?status=true) → selfie
      // Live: /apply-new/approved  |  Local eMandate: /approved?status=true
      setScreen("/apply-new/selfieIntro");
    }}
  >
    Proceed
  </button>
)}
      </div>
    </section>
  );
};

export default ApprovedPage;
